import { FC, Fragment } from 'react';
import { Flex, Paper, Title, TitleOrder } from '@mantine/core';
import { Divider } from '@common/components';

import classNames from 'classnames';
import styles from './styles.module.scss';

type TCardAlign = 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly' | 'stretch';

interface CardProps {
  children: React.ReactNode;
  title?: string;
  align?: TCardAlign;
  className?: string;
  small?: boolean;
  isDivider?: boolean;
  titleOrder?: TitleOrder;
  m?: number;
  mr?: number;
  mt?: number;
  mb?: number;
  ml?: number;
}

const Card: FC<CardProps> = ({
  children,
  title,
  isDivider = 'true',
  align = 'center',
  className,
  small,
  titleOrder = 2,
  m,
  mr,
  mt,
  mb,
  ml,
}): JSX.Element => {
  return (
    <Paper
      m={m}
      mr={mr}
      ml={ml}
      mt={mt}
      mb={mb}
      className={classNames(styles.card, className, { [styles.cardSmallHeight]: small })}>
      {title && (
        <Fragment>
          <Title order={titleOrder} size={18} weight={700} pt={16} mx={12} color="#264547">
            {title}
          </Title>
          {isDivider && <Divider color={'light-purple'} />}
        </Fragment>
      )}
      <Flex align={align} direction={'column'} p={24}>
        {children}
      </Flex>
    </Paper>
  );
};

export default Card;
